var customerAnswers = {};

$( document ).ready(function() {  
    let buttons = document.getElementsByClassName('quiz__option');
  	let backButtons = document.getElementsByClassName('back-btn');
  	let scrollArrows = document.getElementsByClassName('scroll-arrow');
  
    for (let button of buttons){
      button.addEventListener('click', function(){
        
        if(this.getAttribute('data-type') === 'answer'){		
          	addAnswer(button);
          	checkNoOption();
          	nextScreen(button);
        }
      });
    }
  
  	for (let backBtn of backButtons){
      backBtn.addEventListener('click', function(){
       
        if(this.getAttribute('data-type') === 'back'){
          	backScreen(backBtn)
        }
      });
    }
  
	for (let arrow of scrollArrows){
      arrow.addEventListener('click', function(){
      	scrollArrow(arrow)
      });
    }
});

function addAnswer(button){
  	let question = button.dataset.current;
	let answer = button.dataset.answer;
  	customerAnswers[question] = (answer);
}

function nextScreen(button){
	let currentId = button.dataset.current;
  	let nextId = button.dataset.next;
  	let screen = document.getElementById(nextId);
  
  	if (nextId == 'last'){
  		answerScreen()
  	}	
  	
  	screen.style.left = '0px';
  	$('body').animate({ scrollTop: "0px" }, 1000);
  	setTimeout(() => {changePosition(currentId, nextId);}, 500)
    setTimeout(function(){
      document.getElementById(currentId).style.display = 'none';
    }, 1000)
    
}

function backScreen(button){
	let currentId = button.dataset.current;
  	let nextId = button.dataset.next;
  	let screen = document.getElementById(currentId);

    document.getElementById(nextId).style.display = 'block';
  	screen.style.left = '-9999px';
  	$('body').animate({ scrollTop: "0px" }, 1000);
  	changePosition(currentId, nextId);
    hideReviews();
    hideInspiration();
}

function answerScreen(){
  let answer1 = customerAnswers.q1;
  let answer2 = customerAnswers.q2;
  let answer3 = customerAnswers.q3;
  let answer4 = customerAnswers.q4;

  let answerContainer = document.getElementById('answer');
  answerContainer.innerHTML = answers[answer1][answer2][answer3][answer4];

  displayReviews();
  displayInspiration();
  addDropdownFunction();
}

function changePosition(current, next){
	let currentId = current;
  	let nextId = next;
  	
  	let currentScreen = document.getElementById(currentId);
    let nextScreen = document.getElementById(nextId);
    
    nextScreen.style.position = 'relative';
    nextScreen.style.opacity = 1 ;
    currentScreen.style.position = 'absolute';
    currentScreen.style.opacity = 0;
}

function checkNoOption(){  
  let hide = document.querySelector("[data-answer='clipin']");

  if (customerAnswers.q2 == 'short' && customerAnswers.q3 == 'thicker'){
  	hide.style.display = 'none';
  }
  else{
  	hide.style.display = 'flex';
  }
}

//Arrow functions
function scrollArrow (button){
  	let target = button.getAttribute("data-target");
  	let direction = button.getAttribute("data-direction");
  	let speed = parseInt(button.getAttribute("data-speed"));
  	let distance = parseInt(button.getAttribute("data-distance"));
  	let step = parseInt(button.getAttribute("data-step"));
	let container = document.getElementsByClassName(target)[0];
  
  	sideScroll(container,direction,speed,distance,step);
}

function sideScroll(element,direction,speed,distance,step){
    scrollAmount = 0;
    var slideTimer = setInterval(function(){
        if(direction == 'left'){
            element.scrollLeft -= step;
        } else {
            element.scrollLeft += step;
        }
        scrollAmount += step;
        if(scrollAmount >= distance){
            window.clearInterval(slideTimer);
        }
    }, speed);
}

// dropdown functions
function addDropdownFunction(){
  $('#dropdown-btn').click(openAndClose)
}

function openAndClose(){
  let currentStatus = $('.sign').text();

  $('#dropdown-hidden').toggleClass('hidden');

  if(currentStatus === '+ '){
    $('.sign').text('- ')
    $('.sub-text').text('(click to close)')
  } else{
    $('.sign').text('+ ')
    $('.sub-text').text('(click to open)')
  }
}

// Inspiration functions
function displayInspiration(){
  let answerId = $('.answer__captal').text().toLowerCase().replaceAll(" ", "-");
  $("#"+answerId).css({
    position: 'relative',
    left: '0px'
  });
}

function hideInspiration(){
  $('.inspiration-outer').removeAttr('style');
}

// Displays reviews and inspiration
function displayReviews(){
  $('.reviews-outer-container').css({
    position: 'relative',
    left: '0px'
  });
}

function hideReviews(){
  $('.reviews-outer-container').removeAttr('style');
}